import React from "react";
import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
} from "@chakra-ui/react";
import { Controller, useFormContext } from "react-hook-form";

import { IFormField } from "./fieldTypes";

/**
 * JsonForm Multiple Image Field component.
 * @param props see {@link IFormField}
 */
export function MultipleImageField({
  field,
  isRequired,
  register,
  disabled = false,
  errorMessage = "",
}: IFormField) {
  const { control } = useFormContext();
  const regResult = React.useMemo(
    () => ({ ...register(field.fieldName, field.config), ref: undefined }),
    [register, field],
  );

  return (
    <FormControl isRequired={isRequired} isInvalid={!!errorMessage}>
      <FormLabel>{field.label}</FormLabel>
      <Controller
        {...regResult}
        control={control}
        render={({ field: { value, onChange, ...field } }) => {
          return (
            <Input
              {...field}
              value={value?.fileName}
              onChange={(evt) =>
                evt.target.files && evt.target.files.length > 0
                  ? onChange(Array.from(evt.target.files))
                  : undefined
              }
              disabled={disabled}
              type="file"
              multiple
              paddingTop="1"
              accept="image/*"
            />
          );
        }}
        rules={{
          validate: {},
        }}
      />
      <FormErrorMessage>{errorMessage}</FormErrorMessage>
      {!errorMessage && field.helperText && (
        <FormHelperText>{field.helperText}</FormHelperText>
      )}
    </FormControl>
  );
}
